/**
 * Returns a session ID for the the current tab, lets use differentiate different
 * tabs so that can have multiple multiplayer clients open at once and send the correct
 * messages to the correct tab.
 *
 * The sessionsId is just a unique identifier for the current tab
 */
export const getDesignerSessionId = (): string => {
  const parentWindow = document?.defaultView?.parent;

  let id: string;

  // if running in Cypress, then create a unique-ish ID this way -- can't
  // use sessionStorage since it's shared across clients.
  // @ts-expect-error - TS2339 - Property '__Cypress__' does not exist on type 'Window'.
  if (process.env.NODE_ENV === 'development' && parentWindow.__Cypress__) {
    const ownerIframe = Array.prototype.find.call(
      parentWindow?.document.getElementsByTagName('iframe'),
      (iframe) => {
        return iframe.contentDocument === document;
      }
    );

    // if no instanceId, then it's the main
    id = ownerIframe?.dataset?.instanceId || `main-session`;
  } else {
    // window.name is the only way AFAIK to store tab IDs. Session storage
    // doesn't work since it's duplicated between tabs
    const tabId = (window.name.match(/\[tabId=(.*?)\]/) || [])[1];
    if (!tabId) {
      id = `${Date.now()}-${Math.round(Math.random() * 999999)}`;

      // Store tab ID in a special string so that it doesn't
      // clobber other data that might be stored in window.name
      window.name = `[tabId=${id}]` + window.name;
    } else {
      id = tabId;
    }
  }

  return id;
};
